import { z } from "zod";

export const ExtraReportItemSchema = z.object({
    property_id: z.string(),
    booking_room_id: z.string(),
    invoice_number: z.string(),
    room_type_id: z.string(),
    room_type_name: z.string(),
    checkin_date: z.string(),
    checkout_date: z.string(),
    customer_name: z.string(),
    customer_surname: z.string().nullable().optional(),
    customer_full_name: z.string(),
    product: z.string(),
    price: z.string(),
    quantity: z.number(),
    amount: z.string(),
    date: z.string(),
    created_at: z.string(),
});

export const ExtraReportResponseSchema = z.object({
    success: z.boolean(),
    message: z.string().optional(),
    code: z.number().optional(),
    data: z.array(ExtraReportItemSchema),
    total_qty: z.number().optional(),
    total_amount: z.string().optional(),
});

export type ExtraReportItem = z.infer<typeof ExtraReportItemSchema>;
export type ExtraReportResponse = z.infer<typeof ExtraReportResponseSchema>;
